<div class="container">
  <div fxFlex fxLayout="column" fxFill fxLayoutGap="5">
    <div fxLayout="row" style="padding: 2rem" fxLayoutAlign="center stretch" fxLayoutGap="10" fxFill>
      <div fxLayout="row" fxLayoutGap="10" fxFill>
        <div fxFlex="column">
          <h1 mat-card-title>Cadastro de usuários</h1>
          <form [formGroup]="filterForm" fxLayout.gt-lg="row" fxLayout.gt-md="column">
            <div fxFlex style="padding-left: .4rem; padding-right: .4rem;">
              <div fxFlexFill fxLayout="row" fxLayoutAlign="space-between baseline" fxLayoutGap="1rem">
                <div fxFlex="100">
                  <mat-form-field class="field" appearance="standard">
                    <input matInput (keyup)="filter($event)" placeholder="Pesquisar" />
                  </mat-form-field>
                </div>
                <div style="padding: .5rem; display: flex; gap: .5rem;">
                  <!-- <button (click)="syncMerchantUserGroups()" mat-fab color="accent" matTooltip="Sincronizar grupos">
                    <i class="material-icons">sync</i>
                  </button> -->
                  <button class="btn-add" routerLink="/users/create" mat-fab color="primary">
                    <i class="material-icons">add</i>
                  </button>
                </div>
              </div>
            </div>
          </form>

          <!--  TABELA DE DADOS -->
          <div style="margin-top: .7rem;">
            <div class="mat-elevation-z8" fxFill>
              <table #table mat-table [dataSource]="dataSource" matSort>
                <ng-container matColumnDef="name">
                  <mat-header-cell *matHeaderCellDef>
                    <span style="font-weight: 600; font-size: small;">Nome Completo</span>
                  </mat-header-cell>
                  <mat-cell *matCellDef="let row">
                    <span style="text-transform: capitalize;"> {{ row.firstName }} {{row.lastName}}</span>

                  </mat-cell>
                </ng-container>

                <!-- <ng-container matColumnDef="image">
                  <mat-header-cell *matHeaderCellDef>
                    <span style="font-weight: 600; font-size: small;">Nome Completo</span>
                  </mat-header-cell>
                  <mat-cell *matCellDef="let row">
                    <span style="text-transform: capitalize;"> {{ row.firstName }} {{row.lastName}}</span>
                  </mat-cell>
                </ng-container> -->

                <ng-container matColumnDef="document">
                  <mat-header-cell *matHeaderCellDef style="justify-content: center;">
                    <span style="font-weight: 600; font-size: small;">CPF / CNPJ</span>
                  </mat-header-cell>
                  <mat-cell *matCellDef="let row" style="justify-content: center;">
                    {{ row?.document ? (row.document | cpf) : ' - ' }}
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="groups">
                  <mat-header-cell *matHeaderCellDef style="justify-content: center;">
                    <span style="font-weight: 600; font-size: small;">Grupos </span>
                  </mat-header-cell>
                  <mat-cell *matCellDef="let row" style="justify-content: center;">
                    {{ getUserGroups(row.userGroups) }}
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="username">
                  <mat-header-cell *matHeaderCellDef>
                    <span style="font-weight: 600; font-size: small;">Usuário</span>
                  </mat-header-cell>
                  <mat-cell *matCellDef="let row">
                    <div class="image-wrapper">
                      <img class="image-label" [src]="getImageUrl(row?.avatarUrl || 'user_img_default.png')" />
                    </div>
                    {{ row.username | lowercase }}
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="createdAt">
                  <mat-header-cell *matHeaderCellDef style="justify-content: center;">
                    <span style="font-weight: 600; font-size: small;">CRIADO EM</span>
                  </mat-header-cell>
                  <mat-cell *matCellDef="let row" style="justify-content: center;">
                    {{ row?.createdAt ? (row.createdAt) : ' - ' }}
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="actions">
                  <mat-header-cell *matHeaderCellDef style="justify-content:center;">
                    <span style="font-weight: 600; font-size: small;">Ações</span>
                  </mat-header-cell>

                  <mat-cell *matCellDef="let row" style="justify-content:center;">
                    <!-- <button mat-icon-button class="btn-lock" matTooltip="Bloquear">
                      <i class="material-icons">lock</i>
                    </button> -->
                    <button mat-icon-button [routerLink]="'edit/'+row.id" class="btn-edit" matTooltip="Editar">
                      <i class="material-icons">edit</i>
                    </button>
                    <button (click)="resetUserPassword(row)" mat-icon-button class="btn-edit" matTooltip="Resetar senha">
                      <i class="material-icons">lock_reset</i>
                    </button>
                    <button (click)="deleteUser(row)" mat-icon-button class="btn-delete" matTooltip="Excluir">
                      <i class="material-icons">delete</i>
                    </button>
                  </mat-cell>
                </ng-container>

                <mat-row *matHeaderRowDef="displayedColumns" mat-header-row></mat-row>
                <mat-row *matRowDef="let row; columns: displayedColumns" mat-row></mat-row>
              </table>
              <mat-paginator style="width: 100%;" [length]="length" [pageSize]="10" showFirstLastButtons
                [pageSizeOptions]="[5, 10, 25, 100]" (page)="pageEvent($event)"></mat-paginator>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
